/**
 * User Center Client Mod 定义
 *
 * user-center-client-mod 的运行时定义，提供：
 * - IUserCenterSlotsService: 用户中心 slot 注册服务
 * - 用户中心页面路由注册
 *
 * 第三方业务 Mod 通过 USER_CENTER_SLOTS_INTERFACE_TAG
 * 从 DI 容器获取 IUserCenterSlotsService 实例，注册自己的 slot。
 */
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG, } from '@hvsin/ui-registry-contracts';
import { USER_CENTER_SLOTS_INTERFACE_TAG, } from '@hvsin/user-center-contracts';
import { UserCenterSlotsService } from './user-center-slots-service.js';
import { UserCenterRegistrar } from './user-center-registrar.js';
/**
 * user-center-client-mod
 *
 * 用户中心页面，支持第三方通过 slot 机制扩展侧边栏内容。
 *
 * 使用方式：
 * ```typescript
 * import { userCenterClientMod } from '@hvsin/mod-user-center-client'
 *
 * await container.loadMods([userCenterClientMod, ...businessMods])
 * ```
 *
 * 第三方 Mod 注册 slot：
 * ```typescript
 * import { USER_CENTER_SLOTS_INTERFACE_TAG } from '@hvsin/user-center-contracts'
 *
 * const myMod: IMod = {
 *   name: 'my-client',
 *   serviceDefs: [{
 *     serviceTag: 'myRegistrar',
 *     serviceImpl: class {
 *       constructor({ userCenterSlots }: any) {
 *         userCenterSlots.registerSlot({
 *           id: 'my-section',
 *           label: '我的功能',
 *           component: MyPanel,
 *         })
 *       }
 *     },
 *     dependencies: [USER_CENTER_SLOTS_INTERFACE_TAG],
 *   }],
 * }
 * ```
 */
export const userCenterClientMod = {
    name: 'user-center-client',
    modDependencies: ['ui-registry'],
    serviceDefs: [
        {
            serviceTag: 'userCenterSlots',
            serviceImpl: UserCenterSlotsService,
            serviceInterfaceTag: USER_CENTER_SLOTS_INTERFACE_TAG,
        },
        {
            serviceTag: 'userCenterRegistrar',
            serviceImpl: UserCenterRegistrar,
            dependencies: [
                PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
                USER_CENTER_SLOTS_INTERFACE_TAG,
            ],
        },
    ],
};
//# sourceMappingURL=mod.js.map